import createAxios from "./axiosHttpMarconi";
export const geonameService = {
  getPaises,
};

function getPaises(filters) {
  const axios = createAxios();
  let urlPath = "geonames/countries?sort=_id&order=ascending";
  if (filters && filters.tipo) {
    urlPath += `&tipo=${filters.tipo}`;
  }
  if (filters && filters.limit) {
    urlPath += `&limit=${filters.limit}`;
  }
  if (filters && filters.token) {
    urlPath += `&${filters.type}=${filters.token}`;
  }

  return axios.get(urlPath);
}
